<div class="navigations">
    <div class="breadCrumb">
      <p><img class="imageHome" src="assets/icon-action-round-home.svg" alt="Home"></p>
      <div class="divPage"> <span>&nbsp; /</span></div>
      <a routerLink='{{previousPath}}' class="previousPages">{{previousPage}}</a>
      <div class="divPage"><span>/</span>{{page}}</div>
    </div>
  </div>
